import { motion } from "framer-motion";
import { SectionHeading, SectionLabel } from "./Section";

const paragraphs = [
  "Most students follow predefined paths. I prefer learning directly from technology itself.",
  "My journey started with competitive examinations, where I developed the discipline to spend months solving difficult problems.",
  "Today, I apply that same mindset to Artificial Intelligence, software development, automation systems, and startup thinking.",
  "I believe the next decade will belong to people who can combine technology, creativity, and execution.",
  "This website documents the beginning of that journey.",
];

export function Manifesto() {
  return (
    <section id="manifesto" className="relative py-32">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_0%,oklch(0.20_0.10_250/0.15),transparent_60%)]" />
      <div className="relative mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 lg:grid-cols-[1fr_1.4fr]">
        <div>
          <SectionLabel>Manifesto</SectionLabel>
          <SectionHeading>
            The Beginning,
            <br />
            Not The Peak.
          </SectionHeading>
        </div>
        <div className="space-y-7 text-lg leading-relaxed text-muted-foreground sm:text-xl">
          {paragraphs.map((p, i) => (
            <motion.p
              key={i}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.06 }}
              className={i === paragraphs.length - 1 ? "text-foreground" : ""}
            >
              {p}
            </motion.p>
          ))}
        </div>
      </div>
    </section>
  );
}
